import actions from './moduleEvolugyActions.js'
import getters from './moduleEvolugyGetters.js'
import auth from './moduleEvolugyAuthActions.js'

export default {
  namespaced: true,
  actions,
  getters,
  auth
}
